import { css, LitElement, html, repeat } from '@hh/global.js';

class HHBundleStep extends LitElement {
  static properties = {
    step: { type: Object },
    currentStep: { type: Number },
    bundle: {
      type: Array
    },
    isFinished: { type: Boolean },
    type: { type: Number },
    sort: { type: String },
  }

  constructor() {
    super();
    this.sort = 'default';
  }

  get sortedProducts() {
    const available = this.step.products.filter((p) => p.available);
    if (this.sort === 'az') {
      return [...available].sort((a, b) => a.title.localeCompare(b.title));
    }
    if (this.sort === 'price_asc') {
      return [...available].sort((a, b) => a.priceCents - b.priceCents);
    }
    if (this.sort === 'price_desc') {
      return [...available].sort((a, b) => b.priceCents - a.priceCents);
    }
    return available;
  }

  render() {
    return html`
      <div class="bundle-step__products">
        ${repeat(
          this.sortedProducts,
            (product) => product.id,
            (product, index) => html`<hh-bundle-product
              .product="${product}"
              .maxStepQty="${this.step.quantity}"
              .bundle="${this.bundle}"
              .currentStep="${this.currentStep}"
              .isDisabled="${this.isFinished}"
              .type="${this.type}"
            >
            </hh-bundle-product>`
        )}
      </div>
    `
  }

  static styles = css`
    .bundle-step__products {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: var(--hh-spacing-sm);
    }

    @media (min-width: 1024px) {
      .bundle-step__products {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  `
}

if (!customElements.get('hh-bundle-step')) {
  customElements.define('hh-bundle-step', HHBundleStep);
}
